import { Injectable, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IErrorInfo } from '../../components/manager/contracts/error-info';
import { BsModalService } from 'ngx-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { ModalFormStatus } from '../../components/manager/contracts/modal-form-status';
import { ModalHandle } from '../../components/manager/contracts/modal-handle';

@Injectable({
    providedIn: 'root'
})
export class ModalFormHostService {

    constructor(private modalService: BsModalService) {
        this.onInit();
    }

    private modalHandles$ = new BehaviorSubject<ModalHandle[]>([]);
    get modalHandles(): ModalHandle[] {return this.modalHandles$.value;}
    set modalHandles(value: ModalHandle[]) {this.modalHandles$.next(value);}

    current: ModalHandle = null;
    current$: Observable<ModalHandle>;

    onInit() {
        this.current$ =
            this.modalHandles$
                .pipe(
                    map(refs => refs.slice(-1)[0]),
                    share()
                );

        this.current$.subscribe(current => this.current = current);
    }

    show(content: string | TemplateRef<any>, options: any) {
        const modalRef = this.modalService.show(content, options);
        this.modalHandles.push(new ModalHandle(modalRef));
        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    setForm(form: NgForm) {
        const current = this.modalHandles.slice(-1)[0];
        current.form = form;

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    destroyModalRef() {
        this.modalHandles.pop();
        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    close() {
        const current = this.modalHandles.slice(-1)[0];
        current.status = ModalFormStatus.Finished;

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

    error(error?: Partial<IErrorInfo>) {
        const current = this.modalHandles.slice(-1)[0];
        current.status = ModalFormStatus.Error;
        current.error = !!error ? error : {};

        this.modalHandles = [
            ...this.modalHandles
        ];
    }

}
